import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/eboxModuleCompartiment/importer/eboxModuleCompartimentImporterActions';

export default importerReducers(actions);
